import { useRef, useState } from "react";

import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import useOrgaoFetch from "./useOrgaoFetch";
import { Orgao } from "../../types/orgao/Orgao";


type Props = {
    isdisabled?: boolean;
    isLoading?: boolean;
    required?: boolean;
    value?: Orgao | null;
    handleSearchChange: (newValue: Orgao) => void;
};


const TxtOrgao = ({
    isdisabled,
    isLoading,

    required,
    value,
    handleSearchChange,

}: Props) => {


    const timeoutRef = useRef<number | null>(null);
    const loading = useRef(false);




    const handleSetLoad = (newValue: boolean) => {
        loading.current = newValue;
    };

    const [inputValue, setInputValue] = useState("");
    const { options } = useOrgaoFetch({ inputValue, handleSetLoad });


    return (
        <Autocomplete

            value={value && value.id ? value : null} // 
            size="small"
            options={options}
            isOptionEqualToValue={(option, value) => option.id === value.id}

            getOptionLabel={(option) => {
                const orgao = option as Orgao;
                return orgao.nome ? orgao.nome : "";
            }}
            loading={loading.current}

            onInputChange={(event, newInputValue) => {

                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                timeoutRef.current = window.setTimeout(() => {
                    setInputValue(newInputValue);


                }, 700); // 300ms delay
            }}

            onChange={(event, newValue) => {
                handleSearchChange(newValue as Orgao);
            }}


            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Órgão"
                    required={required ? true : false}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading.current ? (
                                    <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}

        />
    );








}
export default TxtOrgao;

